import React from 'react';

export const Shield: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.3333 7.45467C13.3333 10.482 11.058 13.3127 7.99999 14C4.94199 13.3127 2.66666 10.482 2.66666 7.45467V4.82534C2.66666 4.28401 2.99399 3.79601 3.43732 3.61534L6.77066 2.25134C7.57932 1.92001 8.42066 1.92001 9.17132 2.22734L12.5047 3.59134C13.006 3.79667 13.3333 4.28401 13.3333 4.82534V7.45467V7.45467Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.11799 7.54864C8.18332 7.61398 8.18332 7.71931 8.11799 7.78464C8.05266 7.84998 7.94732 7.84998 7.88199 7.78464C7.81666 7.71931 7.81666 7.61398 7.88199 7.54864C7.94732 7.48331 8.05266 7.48398 8.11799 7.54864"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.7847 7.54864C10.85 7.61398 10.85 7.71931 10.7847 7.78464C10.7193 7.84998 10.614 7.84998 10.5487 7.78464C10.4833 7.71931 10.4833 7.61398 10.5487 7.54864C10.614 7.48331 10.7193 7.48398 10.7847 7.54864"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.45133 7.54864C5.51667 7.61398 5.51667 7.71931 5.45133 7.78464C5.386 7.84998 5.28067 7.84998 5.21533 7.78464C5.15 7.71931 5.15 7.61398 5.21533 7.54864C5.28067 7.48331 5.386 7.48398 5.45133 7.54864"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
